/**
* DO NOT EDIT THIS FILE.
* See the following change record for more information,
* https://www.drupal.org/node/2815083
* @preserve
**/
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regeneratorRuntime() { "use strict"; _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var ApiUtils = function () {
  function ApiUtils() {
    _classCallCheck(this, ApiUtils);
  }
  return _createClass(ApiUtils, null, [{
    key: "buildProviderAlias",
    value: function buildProviderAlias(linkedTitle) {
      var parser = new DOMParser();
      var linkElement = parser.parseFromString(linkedTitle, 'text/html');
      return linkElement.body.firstElementChild.href;
    }
  }, {
    key: "searchLocationByNid",
    value: function () {
      var _searchLocationByNid = _asyncToGenerator(_regeneratorRuntime().mark(function _callee(nid) {
        var endpoint;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              endpoint = "/".concat(window.location.pathname.split('/')[1], "/search-location/rest?search=&nid=").concat(nid, "&page=0");
              return _context.abrupt("return", ApiUtils.fetchAllRestAPIPages(endpoint));
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function searchLocationByNid(_x) {
        return _searchLocationByNid.apply(this, arguments);
      }
      return searchLocationByNid;
    }()
  }, {
    key: "getProviderByNPIAndMapToConfirmation",
    value: function () {
      var _getProviderByNPIAndMapToConfirmation = _asyncToGenerator(_regeneratorRuntime().mark(function _callee2(npi) {
        var provObj;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return ApiUtils.searchProvidersByNpi(npi);
            case 2:
              provObj = _context2.sent.rows;
              if (!(provObj.length > 0)) {
                _context2.next = 5;
                break;
              }
              return _context2.abrupt("return", ApiUtils.mapFieldsToConfirmationFormat(provObj[0]));
            case 5:
              return _context2.abrupt("return", null);
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function getProviderByNPIAndMapToConfirmation(_x2) {
        return _getProviderByNPIAndMapToConfirmation.apply(this, arguments);
      }
      return getProviderByNPIAndMapToConfirmation;
    }()
  }, {
    key: "mapFieldsToConfirmationFormat",
    value: function mapFieldsToConfirmationFormat(objectToMap) {
      return {
        field_provider_npi_number: objectToMap.field_provider_npi_number,
        field_hero_banner: {
          field_hero_banner_text: {
            value: objectToMap.field_hero_banner_text_1
          },
          field_media_image: {
            field_media_image: {
              image_style_uri: {
                webp: objectToMap.hero_url
              }
            }
          },
          field_is_luminis_health_provider: objectToMap.field_is_luminis_health_provider === '1',
          field_ratings_label: {
            field_label: objectToMap.field_ratings_label
          },
          field_no_ratings_link: {
            field_link_block_link: {
              uri: objectToMap.field_no_rating_link,
              title: objectToMap.field_no_rating_text
            }
          },
          field_luminis_health_provider_la: {
            field_label: objectToMap.field_is_luminis_health_provider_label
          },
          field_luminis_health_provider_to: {
            field_label: objectToMap.field_luminis_health_provider_to
          },
          field_affiliated_provider_label: {
            field_label: objectToMap.field_affiliated_provider_label
          },
          field_affiliate_provider_toolti2: {
            field_label: objectToMap.field_affiliated_provider_tooltip
          },
          field_offering_telehealth_label: {
            field_label: objectToMap.field_offering_telehealth_label
          },
          field_accepting_new_patients_lab: {
            field_label: objectToMap.field_accepting_new_patients_lab
          }
        },
        field_specialty_list: objectToMap.field_specialty_list,
        field_subspecialty_list: objectToMap.field_subspecialty_list,
        path: {
          alias: ApiUtils.buildProviderAlias(objectToMap.title)
        },
        field_offering_telehealth: objectToMap.field_offering_telehealth === '1',
        field_accepting_new_patients: objectToMap.field_accepting_new_patients === '1'
      };
    }
  }, {
    key: "searchProvidersByNpi",
    value: function () {
      var _searchProvidersByNpi = _asyncToGenerator(_regeneratorRuntime().mark(function _callee3(npis) {
        var npiString;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              npiString = '';
              if (typeof npis === 'string') {
                npiString = npis;
              } else {
                npiString = ApiUtils.createUrlFriendlyStringParamsFromArray(npis);
              }
              return _context3.abrupt("return", ApiUtils.fetchAllRestAPIPages("/".concat(window.location.pathname.split('/')[1], "/search-provider/rest?search=&npi=").concat(npiString)));
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      function searchProvidersByNpi(_x3) {
        return _searchProvidersByNpi.apply(this, arguments);
      }
      return searchProvidersByNpi;
    }()
  }, {
    key: "createUrlFriendlyStringParamsFromArray",
    value: function createUrlFriendlyStringParamsFromArray(array) {
      var paramString = '';
      array.forEach(function (item) {
        if (paramString.length > 0) {
          paramString = "".concat(paramString, "+").concat(item);
        } else {
          paramString = "".concat(item);
        }
      });
      return paramString;
    }
  }, {
    key: "makeMnemonicHumanReadable",
    value: function () {
      var _makeMnemonicHumanReadable = _asyncToGenerator(_regeneratorRuntime().mark(function _callee4(mnemonic) {
        var jsonapiQuery, responseQuery, response, withSpaces;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (!mnemonic) {
                _context4.next = 20;
                break;
              }
              jsonapiQuery = "/".concat(window.location.pathname.split('/')[1], "/jsonapi/taxonomy_term/visit_types?filter[field_mnemonic][condition][path]=field_mnemonic&filter[field_mnemonic][condition][operator]==&filter[field_mnemonic][condition][value]=").concat(mnemonic);
              _context4.prev = 2;
              _context4.next = 5;
              return fetch(jsonapiQuery, {
                method: 'GET'
              });
            case 5:
              responseQuery = _context4.sent;
              if (responseQuery.ok) {
                _context4.next = 8;
                break;
              }
              throw new Error("Server responded with status code ".concat(responseQuery.status));
            case 8:
              _context4.next = 10;
              return responseQuery.json();
            case 10:
              response = _context4.sent;
              if (!(response.data && response.data[0])) {
                _context4.next = 13;
                break;
              }
              return _context4.abrupt("return", response.data[0].attributes.name);
            case 13:
              _context4.next = 18;
              break;
            case 15:
              _context4.prev = 15;
              _context4.t0 = _context4["catch"](2);
              return _context4.abrupt("return", {
                statusCode: 'Bad Request',
                message: 'Error fetching data'
              });
            case 18:
              withSpaces = mnemonic.replace(/_/g, ' ');
              return _context4.abrupt("return", withSpaces.replaceAll(/\S*/g, function (word) {
                return "".concat(word.slice(0, 1)).concat(word.slice(1).toLowerCase());
              }));
            case 20:
            case "end":
              return _context4.stop();
          }
        }, _callee4, null, [[2, 15]]);
      }));
      function makeMnemonicHumanReadable(_x4) {
        return _makeMnemonicHumanReadable.apply(this, arguments);
      }
      return makeMnemonicHumanReadable;
    }()
  }, {
    key: "getLocationFromURL",
    value: function getLocationFromURL() {
      var urlParams = new URLSearchParams(window.location.href.substring(window.location.href.indexOf('?')));
      return urlParams.get('location');
    }
  }, {
    key: "fetchJSONApiRequest",
    value: function () {
      var _fetchJSONApiRequest = _asyncToGenerator(_regeneratorRuntime().mark(function _callee5(url) {
        var response, data, next, fetched;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              _context5.next = 3;
              return fetch(url);
            case 3:
              response = _context5.sent;
              _context5.next = 6;
              return response.json();
            case 6:
              data = _context5.sent;
              if (response.ok) {
                _context5.next = 9;
                break;
              }
              throw new Error("Server responded with status code ".concat(response.status));
            case 9:
              if (data.links.next !== undefined) {
                if (data.links.next.pathname) {
                  next = data.links.next.pathname + data.links.next.search;
                } else {
                  next = data.links.next.href;
                }
              }
              if (!next) {
                _context5.next = 16;
                break;
              }
              _context5.next = 13;
              return ApiUtils.fetchJSONApiRequest(next);
            case 13:
              fetched = _context5.sent;
              data.data = [].concat(_toConsumableArray(data.data), _toConsumableArray(fetched.data));
              if (fetched.included) {
                data.included = [].concat(_toConsumableArray(data.included), _toConsumableArray(fetched.included));
              }
            case 16:
              return _context5.abrupt("return", data);
            case 19:
              _context5.prev = 19;
              _context5.t0 = _context5["catch"](0);
            case 21:
            case "end":
              return _context5.stop();
          }
        }, _callee5, null, [[0, 19]]);
      }));
      function fetchJSONApiRequest(_x5) {
        return _fetchJSONApiRequest.apply(this, arguments);
      }
      return fetchJSONApiRequest;
    }()
  }, {
    key: "fetchAllRestAPIPages",
    value: function fetchAllRestAPIPages(searchStringWithoutPage) {
      var currentPage = 0;
      var allResults = [];
      function fetchPage(page) {
        return fetch("".concat(searchStringWithoutPage, "&page=").concat(page)).then(function (res) {
          return res.json();
        }).then(function (results) {
          allResults = allResults.concat(results || []);
          var pager = results.pager;
          if (pager && pager.current_page < pager.total_pages - 1) {
            return fetchPage(pager.current_page + 1);
          }
          return allResults.length === 1 ? allResults[0] : allResults;
        }, function (error) {
          console.error(error);
          throw error;
        });
      }
      return fetchPage(currentPage);
    }
  }, {
    key: "getProviderSpecialtiesArray",
    value: function getProviderSpecialtiesArray(data) {
      if (!data || data.field_specialty_list === null && data.field_subspecialty_list === null) return '';
      var getTitles = function getTitles(list) {
        if (!Array.isArray(list)) {
          if (typeof list === 'string') {
            return list;
          }
          return '';
        }
        return list.map(function (item) {
          return item ? item.field_title : null;
        }).filter(function (item) {
          return item !== null;
        }).join(', ');
      };
      var specialties = getTitles(data.field_specialty_list);
      var subspecialties = getTitles(data.field_subspecialty_list);
      if (subspecialties && specialties) {
        return "".concat(specialties, ", ").concat(subspecialties);
      }
      return specialties || subspecialties || '';
    }
  }]);
}();
export { ApiUtils as default };